import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../../core/common/dataTable/index";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import Spin from "antd/es/spin";
import { Button, Checkbox, CheckboxChangeEvent, Input, Select } from "antd";
import { CloseCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { FilterDropdownProps } from "antd/es/table/interface";
import { exam } from "../../../../../core/data/json/exam";
import { all_routes } from "../../../../router/all_routes";
import { useUserPermissions } from "../../../../UserPermissionsContext";
type Admin = {
    id: number;
    phone_number: string;
    name: string;
    email: string;
    lead_source: string;
    notes: string;
    address: string;
};

type Agent = {
    id: number;
    display_name: string;
};

const { Option } = Select;

const PrismPendingEmployeeDetails = () => {
    const routes = all_routes;
    const navigate = useNavigate();
    const jwtToken = Cookies.get("authToken");
    const { userPermissions, webApi } = useUserPermissions();
    const [isLoading, setIsLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [admin, setAdmin] = useState<Admin[]>([]);
    const [from, setFrom] = useState();
    const [to, setTo] = useState<number>();
    const [totalCount, setTotalCount] = useState();
    const [currentPage, setCurrentPage] = useState(() => {
        const savedPage = localStorage.getItem("prismPendingLeadsCurrentPage");
        return savedPage ? JSON.parse(savedPage) : 1;
    });
    useEffect(() => {
        localStorage.setItem("prismPendingLeadsCurrentPage", JSON.stringify(currentPage));
    }, [currentPage]);
    const [pageSize, setPageSize] = useState<number>(10);
   const [searchText, setSearchText] = useState<string>(() => {
  return localStorage.getItem("prismPendingLeadsSearchText") || "";
});

useEffect(() => {
  localStorage.setItem(
    "prismPendingLeadsSearchText",
    searchText
  );
}, [searchText]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [AsignshowCard, setAsignShowCard] = useState(false);
    const [agentsLoading, setAgentsLoading] = useState(false);
    const [templateLoading, setTemplateLoading] = useState(false);
    const [unAssignLoading, setUnAssignLoading] = useState(false);
    const [unAssignAllLoading, setUnAssignAllLoading] = useState(false);
    const [selectedAgent, setSelectedAgent] = useState<string[]>([]);
    const [agentsDropdown, setAgentsDropdown] = useState<Agent[]>([]);
    const [agentsFilterDropdown, setAgentsFilterDropdown] = useState<Agent[]>([]);

    const [souresDropdown, setSourcesDropdown] = useState<{ id: number; name: string }[]>([]);
    const [statusDropdown, setStatusDropdown] = useState<{ id: number; name: string }[]>([]);

    const [selectedSourceFilter, setSelectedSourceFilter] = useState<number>(() => {
        const saved = localStorage.getItem("CallParticipentselectedSourceFilter");
        return saved !== null ? Number(saved) : 0;
    });


    const [selectedStatusFilter, setSelectedStatusFilter] = useState<number>(() => {
        const saved = localStorage.getItem("CallParticipentselectedStatusFilter");
        return saved !== null ? Number(saved) : 0;
    });
    const [selectedAgentFilter, setSelectedAgentFilter] = useState<number>(() => {
        const saved = localStorage.getItem("CallParticipentselectedAgentFilter");
        return saved !== null ? Number(saved) : 0;
    });

    const checkPermission = (action: any, subject: any) => {
        return userPermissions.some(
            (ability) => ability.action === action && ability.subject === subject
        );
    };
    const handleClearAgent = () =>
        setSelectedAgentFilter(0);

    const handleClearSource = () =>
        setSelectedSourceFilter(0);
    const handleClearStatus = () =>
        setSelectedStatusFilter(0);

    useEffect(() => {
        localStorage.setItem(
            "CallParticipentselectedSourceFilter",
            selectedSourceFilter.toString()
        );
    }, [selectedSourceFilter]);

    useEffect(() => {
        localStorage.setItem(
            "CallParticipentselectedStatusFilter",
            selectedStatusFilter.toString()
        );
    }, [selectedStatusFilter]);
    useEffect(() => {
        localStorage.setItem(
            "CallParticipentselectedAgentFilter",
            selectedAgentFilter.toString()
        );
    }, [selectedAgentFilter]);


    useEffect(() => {
        if (!checkPermission("view_schoollead", "schoollead")) {
            navigate(routes.login2);
        } else {
            fetchData(currentPage, pageSize, searchText);

        }
    }, [userPermissions]);



    useEffect(() => {
        fetchData(currentPage, pageSize, searchText);
    }, [selectedAgentFilter, searchText, currentPage, pageSize, selectedSourceFilter, selectedStatusFilter,]);

    const options = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
        },
    };

    const fetchGroupsData = async (
        page: number,
        pageSize: number,
        searchText: string
    ) => {
        let apiUrl = `${webApi}/school_leads/school_leads/?team_type_id=1&page=${page}&page_size=${pageSize}&search=${searchText}`;
        if (selectedSourceFilter !== 0) {
            apiUrl += `&source=${selectedSourceFilter}`;
        }
        if (selectedStatusFilter !== 0) {
            apiUrl += `&status=${selectedStatusFilter}`;
        }
        if (selectedAgentFilter !== 0) {
            apiUrl += `&agent=${selectedAgentFilter}`;
        }

        const response = await fetch(apiUrl
            ,
            options
        );
        if (!response.ok) {
            const errorData = await response.json();
            if (errorData.code === "token_not_valid") {
                navigate("/login");
            }
            throw new Error(errorData.detail || "Failed to fetch user data");
        }
        return await response.json();
    };

    const fetchSourcesData = async () => {
        const response = await fetch(`${webApi}/school_leads/lead_source_dropdown/`, options);
        if (!response.ok) {
            const errorData = await response.json();
            if (errorData.code === "token_not_valid") {
                navigate("/login");
            }
            throw new Error(errorData.detail || "Failed to fetch sources data");
        }
        return await response.json();
    };

    const fetchStatusData = async () => {
        const response = await fetch(`${webApi}/school_leads/lead_status_dropdown/`, options);
        if (!response.ok) {
            const errorData = await response.json();
            if (errorData.code === "token_not_valid") {
                navigate("/login");
            }
            throw new Error(errorData.detail || "Failed to fetch sources data");
        }
        return await response.json();
    };

    const fetchAgentsData = async () => {
        const response = await fetch(`${webApi}/school_leads/team_members_dropdown_for_list_filters/1/`, options);
        if (!response.ok) {
            const errorData = await response.json();
            if (errorData.code === "token_not_valid") {
                navigate("/login");
            }
            throw new Error(errorData.detail || "Failed to fetch sources data");
        }
        return await response.json();
    };


    const fetchTemplate = async () => {
        setTemplateLoading(true);
        try {
            const response = await fetch(
                `${webApi}/school_leads/school_leads_template_download/`,
                options
            );

            if (!response.ok) {
                const errorData = await response.json();

                if (errorData.code === "token_not_valid") {
                    navigate("/login");
                }

                throw new Error(errorData.detail || "Failed to download template");
            }

            // Convert response to blob (NOT json)
            const blob = await response.blob();

            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;

            // Set filename (you can also extract from response headers)
            link.download = "school_leads_template.xlsx";

            document.body.appendChild(link);
            link.click();

            // Cleanup
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            // console.error("Download failed:", error.message);
        }
        finally {
            setTemplateLoading(false);

        }
    };



    const fetchData = async (
        page: number,
        pageSize: number,
        searchText: string
    ) => {
        setIsLoading(true); // Start loading
        try {
            const [groupsData, statusDropdown, sourceDropdown, agentsDropdown] = await Promise.all([
                fetchGroupsData(page, pageSize, searchText),
                fetchStatusData(),
                fetchSourcesData(),
                fetchAgentsData(),
            ]);
            setTotalPages(groupsData.total_pages);
            setAdmin(groupsData.results);
            setStatusDropdown(statusDropdown);
            setSourcesDropdown(sourceDropdown);
            setAgentsFilterDropdown(agentsDropdown.results);
            // setPermissions(permissionsData.results);
            setCurrentPage(groupsData.current_page_number);
            setFrom(groupsData.from);
            setTo(groupsData.to);
            setTotalCount(groupsData.total_count);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false); // Stop loading
        }
    };

    const handleTableChange = (pagination: any) => {
        const { current, pageSize } = pagination;
        setCurrentPage(current);
        setPageSize(pageSize);
        // fetchData(current, pageSize, searchText); // Fetch new data based on the updated pagination
    };

    const handleSearch = (value: string) => {
        setSearchText(value);
        // fetchData(currentPage, pageSize, value);
    };

    const handleSelect = (
        student_id: any,
        selectedRowKeys: string[],
        setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
    ) => {
        const selectedIds = [...selectedRowKeys];
        const index = selectedIds.indexOf(student_id);
        if (index >= 0) {
            selectedIds.splice(index, 1);
        } else {
            selectedIds.push(student_id);
        }
        setSelectedRowKeys(selectedIds);
    };

    const handleSelectAll = (
        e: CheckboxChangeEvent,
        data: { id: any }[],
        setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
    ) => {
        if (e.target.checked) {
            const allIds = data.map((item) => item.id);
            setSelectedRowKeys(allIds);
        } else {
            setSelectedRowKeys([]);
        }
    };

    const handleAgentAssignment = async (e: { preventDefault: () => void }) => {
        e.preventDefault();
        setAgentsLoading(true);
        try {
            const response = await fetch(
                `${webApi}/school_leads/assign_agents_to_school_leads/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                    body: JSON.stringify({
                        school_lead_ids: selectedRowKeys,
                        agent_id: selectedAgent,
                        // target_date_: targetDate,
                    }),
                }
            );

            const data = await response.json();
            if (!response.ok) {
                // setDangerToastMessage(data.message);
                // setShowSolidDangerToast(true);
                // throw new Error("Failed to assign agent");
            }

            console.log("Agent assigned successfully", data);
            setSelectedRowKeys([]);
            setSelectedAgent([]);
            // setTargetDate("");

            setAsignShowCard(false);
        } catch (error) {
            console.error("Failed to assign agent", error);
        } finally {
            setAgentsLoading(false);
            fetchData(currentPage, pageSize, searchText);
        }
    };

    const handleAgentUnAssignment = async (e: { preventDefault: () => void }) => {
        e.preventDefault();
        setUnAssignLoading(true);
        try {
            const response = await fetch(
                `${webApi}/school_leads/unassign_agents_for_school_leads/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                    body: JSON.stringify({
                        school_lead_ids: selectedRowKeys,
                        // agent_id: selectedAgent,
                        // target_date_: targetDate,
                    }),
                }
            );

            const data = await response.json();
            if (!response.ok) {
                // setDangerToastMessage(data.message);
                // setShowSolidDangerToast(true);
                // throw new Error("Failed to assign agent");
            }

            console.log("Agent assigned successfully", data);
            setSelectedRowKeys([]);
            setSelectedAgent([]);
            // setTargetDate("");

            setAsignShowCard(false);
        } catch (error) {
            console.error("Failed to assign agent", error);
        } finally {
            setUnAssignLoading(false);
            fetchData(currentPage, pageSize, searchText);
        }
    };

    const handleAgentAllUnAssignment = async (e: { preventDefault: () => void }) => {
        e.preventDefault();
        setUnAssignAllLoading(true);
        try {
            const response = await fetch(
                `${webApi}/school_leads/unassign_agents_for_all_school_leads/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                    body: JSON.stringify({
                        // school_lead_ids: selectedRowKeys,
                        // agent_id: selectedAgent,
                        // target_date_: targetDate,
                    }),
                }
            );

            const data = await response.json();
            if (!response.ok) {
                // setDangerToastMessage(data.message);
                // setShowSolidDangerToast(true);
                // throw new Error("Failed to assign agent");
            }

            console.log("Agent assigned successfully", data);
            setSelectedRowKeys([]);
            setSelectedAgent([]);
            // setTargetDate("");

            setAsignShowCard(false);
        } catch (error) {
            console.error("Failed to assign agent", error);
        } finally {
            setUnAssignAllLoading(false);
            fetchData(currentPage, pageSize, searchText);
        }
    };

    const handleSelectChange = (value: string[]) => {
        setSelectedAgent(value);
    };

    const columns = [
        {
            title: "Action",
            dataIndex: "action",
            render: (_text: any, record: { id: any }) => (
                <Checkbox
                    checked={selectedRowKeys.includes(record.id)}
                    onChange={() =>
                        handleSelect(record.id, selectedRowKeys, setSelectedRowKeys)
                    }
                />
            ),
            key: "action",
            // align: "center",
        },
        {
            title: "Student Name",
            dataIndex: "student_name",
            key: "student_name",
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { id: any }
            ) => (
                <Link
                    to={`${routes.prismAddOrUpdateTicket}?id=${record.id}&s1=1`}
                >
                    {text}
                </Link>
            ),
        },
        {
            title: "Parent Name",
            dataIndex: "parent_name",
            key: "parent_name",
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { id: any }
            ) => (
                <Link
                    to={`${routes.prismAddOrUpdateTicket}?id=${record.id}&s1=1`}
                >
                    {text}
                </Link>
            ),
        },
        {
            title: "Gender",
            dataIndex: "gender_name",
            key: "gender_name",
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { id: any }
            ) => (
                <Link
                    to={`${routes.prismAddOrUpdateTicket}?id=${record.id}&s1=1`}
                >
                    {text}
                </Link>
            ),
        },
        {
            title: "Current School",
            dataIndex: "current_school",
            key: "current_school",
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { id: any }
            ) => (
                <Link
                    to={`${routes.prismAddOrUpdateTicket}?id=${record.id}&s1=1`}
                >
                    {text}
                </Link>
            ),
        },
        {
            title: "Current Class",
            dataIndex: "current_class",
            key: "current_class",
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { id: any }
            ) => (
                <Link
                    to={`${routes.prismAddOrUpdateTicket}?id=${record.id}&s1=1`}
                >
                    {text}
                </Link>
            ),
        },
        {
            title: "Enrolling Class",
            dataIndex: "enrolling_class",
            key: "enrolling_class",
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { id: any }
            ) => (
                <Link
                    to={`${routes.prismAddOrUpdateTicket}?id=${record.id}&s1=1`}
                >
                    {text}
                </Link>
            ),
        },
        {
            title: (<span>
                Source
                <span>

                    {selectedSourceFilter !== 0
                        ? ` (${souresDropdown.find(
                            (state) =>
                                state.id === selectedSourceFilter
                        )?.name
                        })`
                        : ""}
                    {selectedSourceFilter !== 0 && (
                        <CloseCircleOutlined
                            onClick={handleClearSource}
                            style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                        />
                    )}
                </span>
            </span>),
            dataIndex: "source_name",
            key: "source_name",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        showSearch
                        placeholder="Select Source"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            const selected = souresDropdown.find(
                                (s) => s.id === value
                            );
                            setSelectedKeys(selected ? [selected.name] : []);
                            setSelectedSourceFilter(value);
                            confirm();
                        }}
                        allowClear
                        filterOption={(input, option) =>
                            typeof option?.children === "string" &&
                            (option.children as string)
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                    >
                        {souresDropdown.map((state) => (
                            <Select.Option
                                key={state.id}
                                value={state.id}
                            >
                                {state.name
                                }
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ),
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { id: any }
            ) => (
                <Link
                    to={`${routes.prismAddOrUpdateTicket}?id=${record.id}&s1=1`}
                >
                    {text}
                </Link>
            ),
        },
        {
            title: (<span>
                Status
                <span>

                    {selectedStatusFilter !== 0
                        ? ` (${statusDropdown.find(
                            (state) =>
                                state.id === selectedStatusFilter
                        )?.name
                        })`
                        : ""}
                    {selectedStatusFilter !== 0 && (
                        <CloseCircleOutlined
                            onClick={handleClearStatus}
                            style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                        />
                    )}
                </span>
            </span>),
            dataIndex: "status_name",
            key: "status_name",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        showSearch
                        placeholder="Select Status"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            const selected = statusDropdown.find(
                                (s) => s.id === value
                            );
                            setSelectedKeys(selected ? [selected.name] : []);
                            setSelectedStatusFilter(value);
                            confirm();
                        }}
                        allowClear
                        filterOption={(input, option) =>
                            typeof option?.children === "string" &&
                            (option.children as string)
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                    >
                        {statusDropdown.map((state) => (
                            <Select.Option
                                key={state.id}
                                value={state.id}
                            >
                                {state.name
                                }
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ),
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { id: any }
            ) => (
                <Link
                    to={`${routes.prismAddOrUpdateTicket}?id=${record.id}&s1=1`}
                >
                    {text}
                </Link>
            ),
        },




        {
            title: (<span>
                Agent
                <span>

                    {selectedAgentFilter !== 0
                        ? ` (${agentsFilterDropdown.find(
                            (state) =>
                                state.id === selectedAgentFilter
                        )?.display_name
                        })`
                        : ""}
                    {selectedAgentFilter !== 0 && (
                        <CloseCircleOutlined
                            onClick={handleClearAgent}
                            style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                        />
                    )}
                </span>
            </span>),
            dataIndex: "agent_name",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        showSearch
                        placeholder="Select Agent"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            const selected = agentsFilterDropdown.find(
                                (s) => s.id === value
                            );
                            setSelectedKeys(selected ? [selected.display_name] : []);
                            setSelectedAgentFilter(value);
                            confirm();
                        }}
                        allowClear
                        filterOption={(input, option) =>
                            typeof option?.children === "string" &&
                            (option.children as string)
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                    >
                        {agentsFilterDropdown.map((state) => (
                            <Select.Option
                                key={state.id}
                                value={state.id}
                            >
                                {state.display_name
                                }
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ),
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { id: any }
            ) => (
                <Link
                    to={`${routes.prismAddOrUpdateTicket}?id=${record.id}&s1=1`}
                >
                    {text}
                </Link>
            ),
        },
        {
            title: "Action",
            dataIndex: "action",
            render: (_text: any, record: { id: any }) => (
                <div className="d-flex align-items-center">
                    {checkPermission("change_schoollead", "schoollead") && (
                        <Link
                            className="btn btn-icon btn-sm btn-soft-info rounded-pill"
                            to={routes.editPrismLead}
                            state={{ id: record.id }}
                        >
                            <i className="feather-edit" />
                        </Link>
                    )}
                </div>
            ),
        },
    ];

    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    {/* Page Header */}
                    <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                        <div className="my-auto mb-2">
                            <h3 className="page-title mb-1">Pending Leads</h3>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    {/* <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li> */}
                                    <li className="breadcrumb-item active" aria-current="page">
                                        List
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                            <div className="mb-2 me-2">
                                {checkPermission("add_schoollead", "schoollead") && (
                                    <Link to={routes.addPrismLead} className="btn btn-primary">
                                        <i className="ti ti-square-rounded-plus-filled me-2" />
                                        Add Lead
                                    </Link>
                                )}
                            </div>
                            <div className="mb-2 me-2">
                                {checkPermission("add_schoollead", "schoollead") && (
                                    <Link to={routes.prismLeadsUpload} className="btn btn-primary">
                                        {/* <i className="ti ti-square-rounded-plus-filled me-2" /> */}
                                        Import
                                    </Link>
                                )}
                            </div>
                            <div className="mb-2 me-2">
                                {checkPermission("add_schoollead", "schoollead") && (
                                    <button className="btn btn-primary" onClick={fetchTemplate}>
                                        {/* <i className="ti ti-square-rounded-plus-filled me-2" /> */}
                                        {templateLoading ? (<i className="spinner-border spinner-border-sm"></i>) : (<span>Template</span>)}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* /Page Header */}
                    {/* Guardians List */}
                    <div
                        className="card "
                        style={{
                            width: "100%",
                            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                            borderRadius: "10px",
                        }}
                    >
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                            <h4 className="mb-3">Participants List</h4>
                            <div className="d-flex align-items-center flex-wrap ms-auto">
                                <Checkbox
                                    indeterminate={
                                        selectedRowKeys.length > 0 &&
                                        selectedRowKeys.length < admin.length
                                    }
                                    checked={selectedRowKeys.length === admin.length}
                                    onChange={(e) =>
                                        handleSelectAll(e, admin, setSelectedRowKeys)
                                    }
                                >
                                    Select All
                                </Checkbox>

                                {checkPermission("can_assign_agent_to_school_leads", "schoollead") && (
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => setAsignShowCard(true)}
                                        disabled={selectedRowKeys.length === 0}
                                        style={{ marginLeft: "10px", marginBottom: "5px" }}
                                    >
                                        Assign Agent
                                    </button>
                                )}
                                {checkPermission("can_unassign_agent_to_school_leads", "schoollead") && (
                                    <button
                                        className="btn btn-primary"
                                        onClick={handleAgentUnAssignment}
                                        disabled={selectedRowKeys.length === 0}
                                        style={{ marginLeft: "10px", marginBottom: "5px" }}
                                    >
                                        {unAssignLoading ? (<i className="spinner-border spinner-border-sm"></i>) : (<span>Un Assign Agent</span>)}
                                    </button>
                                )}

                                {checkPermission("can_unassign_agent_to_all_school_leads", "schoollead") && (
                                    <button
                                        className="btn btn-primary"
                                        data-bs-toggle="modal"
                                        data-bs-target="#call_confirmation_modal"
                                        style={{ marginLeft: "10px", marginBottom: "5px" }}
                                    >
                                        {unAssignAllLoading ? (<i className="spinner-border spinner-border-sm"></i>) : (<span>Un Assign All Agent</span>)}
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="card-body p-0 py-3">
                            {/* <div
                                className="serch-global text-right"
                                style={{ marginRight: "15px" }}
                            >
                                <input
                                    type="search"
                                    className="form-control form-control-sm mb-3 w-auto float-end"
                                    value={searchText}
                                    placeholder="Search"
                                    onChange={(e) => handleSearch(e.target.value)}
                                    aria-controls="DataTables_Table_0"
                                ></input>
                            </div> */}
                            {isLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "flex-start",
                                        height: "100vh",
                                        paddingTop: "20px",
                                    }}
                                >
                                    <Spin />{" "}
                                    {/* Display loader while loading */}
                                </div>
                            ) : (
                                <Table
                                    columns={columns}
                                    dataSource={admin}
                                    Selection={false}
                                    pagination={{
                                        current: currentPage,
                                        pageSize: pageSize,
                                        locale: { items_per_page: "" },
                                        nextIcon: <span>Next</span>,
                                        prevIcon: <span>Prev</span>,
                                        defaultPageSize: 10,
                                        showSizeChanger: true,
                                        total: totalCount,
                                        showTotal: (total: any, range: any[]) => `${range[0]}-${range[1]} of ${total}`,
                                        pageSizeOptions: ["10", "20", "30", "50", "100"],
                                    }}
                                    onChange={handleTableChange} // Move this outside of pagination
                                    onSearch={handleSearch}
                                    searchText={searchText}
                                />)}
                        </div>
                    </div>
                    {/* /Guardians List */}
                </div>
            </div>
            {AsignshowCard && (
                <>
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0,0,0,0.5)",
                            zIndex: 1049,
                        }}
                    />
                    <div
                        className="card"
                        style={{
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "20%",
                            boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
                            borderRadius: "10px",
                            zIndex: 1050,
                            backgroundColor: "#f9f9f9",
                            padding: "20px",
                        }}
                    >
                        <form onSubmit={handleAgentAssignment}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-3">
                                            <label
                                                className="form-label"
                                                style={{
                                                    paddingBottom: "10px",
                                                    fontWeight: "bold",
                                                    color: "#555",
                                                }}
                                            >
                                                Select Agent
                                            </label>
                                            {agentsLoading ? (
                                                <Spin />
                                            ) : (
                                                <Select
                                                    // mode="multiple" 
                                                    value={selectedAgent}
                                                    onChange={handleSelectChange}
                                                    style={{
                                                        width: "100%",
                                                    }}
                                                    showSearch
                                                    filterOption={(input, option) => {
                                                        if (!option || !option.children) return false; // Check if option or option.children is undefined
                                                        const label = option.children as unknown as string; // Ensure that option.children is treated as a string
                                                        return label
                                                            .toLowerCase()
                                                            .includes(input.toLowerCase());
                                                    }}
                                                >
                                                    {agentsFilterDropdown.map((agent) => (
                                                        <Option key={agent.id} value={agent.id}>
                                                            {agent.display_name}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </div>
                                        {/* <div className="mb-3">
                              <label
                                className="form-label"
                                style={{
                                  paddingBottom: "10px",
                                  fontWeight: "bold",
                                  color: "#555",
                                }}
                              >
                                Target Date
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                value={targetDate}
                                onChange={(e) => setTargetDate(e.target.value)}
                                required
                              />
                            </div> */}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <Button
                                    className="btn btn-light me-2"
                                    onClick={() => setAsignShowCard(false)}
                                >
                                    Cancel
                                </Button>
                                <button
                                    className="btn btn-primary"
                                    type="submit"
                                    disabled={agentsLoading}
                                >
                                    Save Changes
                                </button>
                            </div>
                        </form>
                    </div>
                </>
            )}
            <>
                {/* Delete Modal */}
                <div className="modal fade" id="delete-modal">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <form>
                                <div className="modal-body text-center">
                                    <span className="delete-icon">
                                        <i className="ti ti-trash-x" />
                                    </span>
                                    <h4>Confirm Deletion</h4>
                                    <p>
                                        You want to delete all the marked items, this cant be undone
                                        once you delete.
                                    </p>
                                    <div className="d-flex justify-content-center">
                                        <Link
                                            to="#"
                                            className="btn btn-light me-3"
                                            data-bs-dismiss="modal"
                                        >
                                            Cancel
                                        </Link>
                                        <Link
                                            to="#"
                                            data-bs-dismiss="modal"
                                            className="btn btn-danger"
                                        >
                                            Yes, Delete
                                        </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div
                    className="modal fade"
                    id="call_confirmation_modal"
                    // tabIndex="-1"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Confirm Un Assignment</h4>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <i className="ti ti-x" />
                                </button>
                            </div>
                            <div className="modal-body">
                                {/* <div className="mb-3">
                  <label>Select Number</label>
                  <select
                    className="form-select"
                    value={selectedCallId}
                    onChange={(e) => setSelectedCallId(e.target.value)}
                  >
                    <option value="">Select contact</option>
                    {callOptions.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div> */}
                                <p>Are you sure you want to unassign this All The Leads?</p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    style={{ marginRight: "9px" }}
                                >
                                    No
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    data-bs-dismiss="modal"
                                    onClick={handleAgentAllUnAssignment}
                                >
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /Delete Modal */}
            </>
        </div>
    );
};

export default PrismPendingEmployeeDetails;
